module.exports = __webpack_public_path__ + "images/banner.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner.png
// module id = 958
// module chunks = 2